<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add an execution broker</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-exchange-form">
            <div *ngIf="form.controls.currency"
                 [ngClass]="{'mb-3': form.controls.currency.errors?.length > 0}"
                 class="col-12">
                <app-select
                    [control]="form.controls.currency"
                    [formControlName]="form.controls.currency.name"
                ></app-select>
            </div>
            <div [ngClass]="{'mb-3': form.controls.brokers.errors?.length > 0}" class="col-12">
                <app-radio-group [control]="form.controls.brokers" [formControlName]="form.controls.brokers.name" class="broker-control"></app-radio-group>
            </div>
        </form>
    </ng-container>
</app-dialog>
